import Valkyrie, { viAngleDown, viAngleUp } from "@sippy-platform/valkyrie";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";

import { useFieldContext } from "./useAppForm";

export function NumericField({ description, label, required, disabled, startAdornment, endAdornment, name, ...props }) {
  const field = useFieldContext();

  const hasError = field.state.meta.errors.length >= 1;
  const message = field.state.meta.errors?.map((error) => error?.message).join(" ") || description;

  return (
    <BaseNumberField.Root
      {...props}
      id={field.name}
      name={name}
      value={field.state.value ?? null}
      required={required}
      disabled={disabled}
      onValueChange={(value) => field.handleChange(value)}
      render={(renderProps, state) => (
        <FormControl
          fullWidth
          size="small"
          ref={renderProps.ref}
          disabled={state.disabled}
          required={state.required}
          error={hasError}
          variant="outlined"
        >
          {renderProps.children}
        </FormControl>
      )}
    >
      <InputLabel htmlFor={field.name}>{label}</InputLabel>
      <BaseNumberField.Input
        id={field.name}
        render={(renderProps, state) => (
          <OutlinedInput
            aria-describedby={`${field.name}-helper-text`}
            label={label}
            placeholder={label}
            inputRef={renderProps.ref}
            value={state.inputValue}
            onBlur={(event) => {
              renderProps.onBlur?.(event);
              field.handleBlur();
            }}
            onChange={renderProps.onChange}
            onKeyUp={renderProps.onKeyUp}
            onKeyDown={renderProps.onKeyDown}
            onFocus={renderProps.onFocus}
            slotProps={{
              input: renderProps,
            }}
            startAdornment={startAdornment}
            endAdornment={
              <>
                {endAdornment}
                <InputAdornment
                  position="end"
                  sx={{
                    flexDirection: "column",
                    maxHeight: "unset",
                    alignSelf: "stretch",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    borderStartEndRadius: 8,
                    borderEndEndRadius: 8,
                    contain: "paint",
                    mr: 0.125,
                    "& button": {
                      py: 0,
                      flex: 1,
                      borderRadius: 0,
                    },
                  }}
                >
                  <BaseNumberField.Increment render={<IconButton size="small" aria-label="Increase" />}>
                    <Valkyrie icon={viAngleUp} />
                  </BaseNumberField.Increment>
                  <BaseNumberField.Decrement render={<IconButton size="small" aria-label="Decrease" />}>
                    <Valkyrie icon={viAngleDown} />
                  </BaseNumberField.Decrement>
                </InputAdornment>
              </>
            }
            sx={{ pr: 0 }}
          />
        )}
      />
      {!!message && <FormHelperText id={`${field.name}-helper-text`}>{message}</FormHelperText>}
    </BaseNumberField.Root>
  );
}
